var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrinterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "8.5mm",
    height: "8.5mm",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #7b8dbf;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.8,4.8h-1.4V0H3.6v4.7h-1.4c-1.2,0-2.2,1-2.2,2.3v8.7c0,1.3,1,2.3,2.2,2.3h.6v5.8h13.8l4.7-4.9v-.9h.6c1.2,0,2.2-1,2.2-2.3V7.1c0-1.3-1-2.3-2.2-2.3h0ZM5,1.5h14v3.3H5s0-3.3,0-3.3ZM4.4,22.2v-7h15.1v3.1h0c0,0-3.7,0-3.7,0v3.8s-11.4,0-11.4,0ZM22.4,15.8c0,.3-.3.6-.6.6h-.6v-2.9H2.8v2.9h-.6c-.3,0-.6-.3-.6-.6V7.1c0-.3.3-.6.6-.6h19.6c.3,0,.6.3.6.6v8.7h0ZM17.3,9.2c0,.4-.3.7-.7.7s-.7-.3-.7-.7.3-.7.7-.7.7.3.7.7ZM20.3,9.2c0,.4-.3.7-.7.7s-.7-.3-.7-.7.3-.7.7-.7.7.3.7.7Z"
  })), /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "http://ns.adobe.com/SaveForWeb/1.0/"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    x: 0,
    y: 0.06,
    width: 23.99,
    height: 23.94,
    bottomLeftOrigin: "true"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterIcon);
export default __webpack_public_path__ + "static/media/printer-icon.3d30aee9.svg";
export { ForwardRef as ReactComponent };